// this component is for SMARTLGU
/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PieComponentV2 from '../components/PieComponentV2';
import * as c from '../constants';
import * as actions from '../actions';

import CmsContext from '../../../context/CmsContext';

const ServicesCountV2 = ({ getCounts, counts, getENewsCounts, getCountsSmartCity, countsSmartCity }) => {
  const cmsContext = useContext(CmsContext)
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const { transactions } = counts;
  // const { news_articles } = eNewsCounts;

  useEffect(() => {
    getCounts();
    getENewsCounts();

    // for smart city
    getCountsSmartCity()
  }, []);


  const formatData = (data) => {
    if (!data) return [];
    return Object.keys(data).map((val) => {
      return { name: val, value: +data[val]};
    });
  };

  const renderLegends = (dt) => {
    return dt.map((x) => (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text text-capitalize">{x.name}</div>
      </div>
    ));
  }
    

  // const eBillsData = formatData(
  //   c.E_BILLS.reduce((accumulator, current) => {
  //     return {
  //       ...accumulator,
  //       [current.name]: _.random(90, 200),
  //     };
  //   }, {})
  // );

  // const eCommerceData = formatData(
  //   c.E_COMMERCE.reduce((accumulator, current) => {
  //     return {
  //       ...accumulator,
  //       [current.name]: _.random(90, 200),
  //     };
  //   }, {})
  // );

  // const eServices = formatData(
  //   c.E_SERVICES.reduce((accumulator, current) => {
  //     return {
  //       ...accumulator,
  //       [current.name]: _.random(90, 200),
  //     };
  //   }, {})
  // );

const servicesData = [
  // ...c.E_GOV_AND_SERVICES,
  {
    RPTAX: [
      { name: 'Current', color: !_.get(countsSmartCity, "RPTAX.Current") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "RPTAX.Current")},
      { name: 'Delinquent', color: !_.get(countsSmartCity, "RPTAX.Deliquent") ? '#9FA2A7' : '#A3B3F9', value: _.get(countsSmartCity, "RPTAX.Deliquent")},
    ],
  },
    {
    E_BOSS: [
      { name: 'New', color: !_.get(countsSmartCity, "BPLS.New") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "BPLS.New")},
      { name: 'Renewal', color: !_.get(countsSmartCity, "BPLS.New") ? '#9FA2A7' : '#A3B3F9', value: _.get(countsSmartCity, "BPLS.Renewal")},
      { name: 'Quarterly', color: !_.get(countsSmartCity, "BPLS.New") ? '#9FA2A7' : '#8EEED7', value: _.get(countsSmartCity, "BPLS.Quarterly")},
      { name: 'Delinquent', color: !_.get(countsSmartCity, "BPLS.New") ? '#9FA2A7' : '#87A1D1', value: _.get(countsSmartCity, "BPLS.Delinquent")},
    ],
  },
  {
    BTAX: [
      { name: 'TAX_PAYMENT', color: !_.get(countsSmartCity, "BTAX.TAX PAYMENT") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "BTAX.TAX PAYMENT")},
    ],
  },
  {
    E_CEDULA: [
      { name: 'Individual', color: !_.get(countsSmartCity, "CDL.INDIVIDUAL") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "CDL.INDIVIDUAL")},
      { name: 'Corporation', color: !_.get(countsSmartCity, "CDL.CORPORATION") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "CDL.CORPORATION")},
    ],
  },
  {
    CIVIL_REGISTRY: [ // PSA
      { name: 'Birth Certificate', color: !_.get(countsSmartCity, "PSA.BIRTH CERTIFICATE") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "PSA.BIRTH CERTIFICATE")},
    ],
  },
  {
    OHP: [
      // { name: 'Occupational and Health Permit', color: '#5272AA', value: 0},
      { name: 'New', color: !_.get(countsSmartCity, "OHP.NEW") ? '#9FA2A7' : '#5272AA', value: _.get(countsSmartCity, "OHP.NEW")},
    ],
  },
]

// [{ name: '', color: '#9FA2A7', value: ""}]

  const filterEgovEServices = () => {
    // const services = c.E_GOV_AND_SERVICES || []
    const services = servicesData
    const serviceRenderLists = []
    // maybe refactor later or find a better way to render these values
    if (!_.get(CMS_COMPONENTS, 'REAL_PROPERTY_TAX_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.RPTAX)) // RPT_SERVICES_SUB_MENU
    if (!_.get(CMS_COMPONENTS, 'BTAX_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.BTAX))
    if (!_.get(CMS_COMPONENTS, 'BPLS_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.E_BOSS))
    if (!_.get(CMS_COMPONENTS, 'CEDULA_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.E_CEDULA))
    if (!_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.CIVIL_REGISTRY)) // PSA
    if (!_.get(CMS_COMPONENTS, 'OHP_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.OHP))
    if (!_.get(CMS_COMPONENTS, 'OVRS_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.OVR))

  return serviceRenderLists
  }


  return (
    <div className="container-fluid pie item-box-shadow" style={{ borderRadius: '8px'}}>
      <div className="w-100">
        <h4 className="cms-text-primary font-weight-bold pl-2 mb-4">
          E-Government and E-Services
        </h4>
      </div>
      <div className="services chart-container">
        <div className="row justify-content-center">

          {filterEgovEServices().map((service) => {
            const type = Object.keys(service)
            return (
              <div key={type} className="col-md-6 col-lg-4 col-xl-3 d-flex justify-content-center">
                <div className="bg-muted pie-chart-group">
                  <h5 className="cms-text-primary font-weight-bold my-0 pl-4">{type}</h5>
                  <PieComponentV2 chartData={formatData(countsSmartCity)} services={service[type]} />
                  <div className="legends-wrapper-v2 pl-4">{renderLegends(service[type])}</div>
                </div>
              </div>
            )}
          )}
        </div> 
      </div>
    </div>
  );
}

ServicesCountV2.defaultProps = {
  counts: {},
  // eNewsCounts: {},
  countsSmartCity: {},
};

ServicesCountV2.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
  getENewsCounts: PropTypes.instanceOf(Object).isRequired,
  // eNewsCounts: PropTypes.instanceOf(Object),

  // for smart city
  getCountsSmartCity: PropTypes.instanceOf(Function).isRequired,
  countsSmartCity: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.res`),
  countsSmartCity: _.get(api, `${c.GET_COUNTS_SMART_CITY}.res`),
  eNewsCounts: _.get(api, `${c.GET_ENEWS_COUNTS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ServicesCountV2);
